export const path = "M 6 8 L 2 12 L 6 16 L 6 13 L 18 13 L 18 16 L 22 12 L 18 8 L 18 11 L 6 11 L 6 8 z";
